import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import moment from 'moment';

export default function InfoCotaCapital({ resposta }: { resposta: RespostaCotaCapital }) {
  return (
    <>
        <Table size='small' aria-label="parcelas">
            <TableHead>
                <TableRow>
                    <TableCell>Número</TableCell>
                    <TableCell>Vencimento</TableCell>
                    <TableCell align='right'>Valor</TableCell>
                </TableRow>
            </TableHead>
            <TableBody
            sx={
                {
                    '& .MuiTableRow-root:last-child .MuiTableCell-root': {
                        borderBottom: 'none',
                    },
                }
            }
            >
                {resposta.parcelas.map((parcela: any, index: number) => (
                    <TableRow key={index}>
                        <TableCell>{parcela.numero_parcela}</TableCell>
                        <TableCell>{moment(parcela.data_vencimento).format('DD/MM/YYYY')}</TableCell>
                        <TableCell align='right'>{parcela.valor_parcela}</TableCell>
                    </TableRow>
                ))}
                <TableRow>
                    <TableCell colSpan={2}><b>Total:</b></TableCell>
                    <TableCell align='right'><b>{resposta.valor_total}</b></TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </>
  )
}

type RespostaCotaCapital = {
  valor_total: number;
  parcelas: Array<{
    numero_parcela: number;
    valor_parcela: number;
    data_vencimento: string;
  }>;
};
